import { render, staticRenderFns } from "./WatchSpot.vue?vue&type=template&id=2921ec2e&scoped=true"
import script from "./WatchSpot.vue?vue&type=script&lang=js"
export * from "./WatchSpot.vue?vue&type=script&lang=js"
import style0 from "./WatchSpot.vue?vue&type=style&index=0&id=2921ec2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2921ec2e",
  null
  
)

export default component.exports